@if (formControl()) {
<div class="toggle form-group">
  <mat-form-field class="form-field">
    <input readonly matInput [placeholder]="$safeNavigationMigration(meta()?.name)">
    <mat-slide-toggle class="form-control input-toggle" [formControl]="formControl()!" (change)="onChange($event)"></mat-slide-toggle>
    <mat-hint><strong>{{meta().info}}</strong></mat-hint>
    @if (formControl()?.hasError('form')) {
      <mat-error>
        {{formError}}
      </mat-error>
    }
  </mat-form-field>
</div>
}
